import * as React from 'react';
import styles from './index.less';

interface ImgButtonProps {
  img: string;
  // hoverImg: string;
  width: number;
  height: number;
  disabled?: boolean;
  onClick: () => void;
  alt?: string;
}

function ImgButton({ img, width, height, disabled = false, onClick, alt = '' }: ImgButtonProps) {
  return (
    <div
      className={[styles.img_button, disabled ? styles.disabled : ''].join(' ')}
      style={{
        width,
        height,
      }}
      onClick={onClick}
    >
      <img src={img} alt={alt} className={styles.img} />
    </div>
  );
}

export default ImgButton;
